var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotifications = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 5a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1h20q.135 0 .259.034L14.793 11.5H9.207L1.741 4.034Q1.866 4 2 4m-.966.741Q1 4.866 1 5v14q0 .135.034.259L8.293 12zm.707 15.225Q1.866 20 2 20h20a1 1 0 0 0 .259-.034L14.793 12.5H9.207zm21.225-.707A1 1 0 0 0 23 19V5q0-.135-.034-.259L15.707 12z",
  clipRule: "evenodd"
})));
export default SvgNotifications;